(function () {
    "use strict";

    angular.module("app.search").factory("SearchService", SearchService);

    SearchService.$inject = ["$http", "$q"];

    function SearchService($http, $q) {
        var service = {
            searchProduct: searchProduct,
            searchCategory: searchCategory,
            searchBrand: searchBrand,
            searchGallery: searchGallery,
            searchSalesPoint: searchSalesPoint,
            getLastViewProducts: getLastViewProducts,
        };

        return service;

        function searchProduct(filter, cultures) {
            var deferred = $q.defer();
            var url = cultures + "/General/SearchProduct";

            $http.get(url, { params: filter }).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchCategory(search, cultures) {
            var deferred = $q.defer();
            var url = cultures + "/General/SearchCategory?search=" + search;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchBrand(search, cultures) {
            var deferred = $q.defer();
            var url = cultures + "/General/SearchBrand?search=" + search;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchGallery(search, gallery, cultures) {
            var deferred = $q.defer();
            var url =
                cultures +
                "/General/SearchGallery?search=" +
                search +
                "&gallery=" +
                gallery;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchSalesPoint(search, cultures) {
            var deferred = $q.defer();
            var url = cultures + "/General/SearchSalesPoint/" + search;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getLastViewProducts(cultures) {
            var deferred = $q.defer();
            var url =
                (cultures ? "/" + cultures : "") + "/General/LastViewProducts";
            $http.get(url).then(complete).catch(failed);
            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();
